// Onboarding-request intent (1:1), keyed by bare site_slug:
//   GET|POST|PUT|DELETE /api/v1/sites/{site_slug}/onboarding-request
// Mirrors backend/src/orixen_hub/api/v1/site_onboarding.py. POST creates (server
// generates request_id), PUT updates; neither sends request_id/requested_at.

import { request, type ApiResponse } from "../client";
import type {
  OnboardingRequestConfig,
  OnboardingRequestIn,
} from "../types/onboardingRequest";

const path = (s: string) =>
  `/api/v1/sites/${encodeURIComponent(s)}/onboarding-request`;

export const onboardingRequest = {
  get: (siteSlug: string): Promise<ApiResponse<OnboardingRequestConfig>> =>
    request<OnboardingRequestConfig>("GET", path(siteSlug)),
  create: (
    siteSlug: string,
    body: OnboardingRequestIn,
  ): Promise<ApiResponse<OnboardingRequestConfig>> =>
    request<OnboardingRequestConfig>("POST", path(siteSlug), body),
  update: (
    siteSlug: string,
    body: OnboardingRequestIn,
  ): Promise<ApiResponse<OnboardingRequestConfig>> =>
    request<OnboardingRequestConfig>("PUT", path(siteSlug), body),
  remove: (siteSlug: string): Promise<ApiResponse<void>> =>
    request<void>("DELETE", path(siteSlug)),
};
